module.exports = __webpack_public_path__ + "static/media/beekeeping.e2e3d3c5.jpg";